// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","t_button_column":"fas_t_button_column","touch_point_is_visible":"fas_touch_point_is_visible","show_buttons":"fas_show_buttons"};